export const priceRegex = /^(\d{1,6})(\.\d{1,2})?$/;
export const weightRegex = /^(\d{1,6})(\.\d{1,4})?$/;
